import React from 'react';
import {styled} from "@mui/styles";
import {Box} from "@mui/material";

const Root = styled(Box)(() => ({
  cursor: 'pointer',
  width: '100%',
}));

type CollapsableCardClickableContainerProps = React.ComponentPropsWithoutRef<'div'>

/**
 * MUI Box component styled in the SecurSpace way. Used around the HeaderContainer to make the entire header section look clickable
 * @param children children passed through to the internal Box component
 * @param rest The rest of the Box props that will be passed through to the internal Box component
 * @constructor
 */
const CollapsableCardClickableContainer = ({ children, ...rest}: CollapsableCardClickableContainerProps) => {
  return <Root {...rest}>
    { children }
  </Root>
}

export { CollapsableCardClickableContainer };
